import i18n from "i18next";
import { useState } from "react";
import { useParams } from "react-router";

import { ActionBar } from "../../../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../../../components/AppLayout/components/FPageLayout";
import { PrimaryButton } from "../../../../../../components/Buttons/components/ActionButton";
import { BackButton } from "../../../../../../components/FeatureButtons/BackButton";
import { ResourceName } from "../../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../../core/router/types/routerTypes";
import { CardDefinitionCreateForm } from "../components/forms/CardDefinitionCreateForm";

export const CardDefinitionCreateFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const { cardImplementationId } = useParams();
    const backUrl = `${BASE_PATH}/${ResourceName.CARD_IMPLEMENTATIONS}/${FORM_ACTION.EDIT}/${cardImplementationId}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.cardDefinitionsCreateFormPage" />
                <ActionBar>
                    <PrimaryButton name="continue_button" disabled={false} onClick={triggerFormSubmit}>
                        {i18n.t("button.continue")}
                    </PrimaryButton>
                    <BackButton isDisabled={false} url={backUrl} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CardDefinitionCreateForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
